<app-content-container data-testid="admin-news">
  <app-banner-card
    [header]="'pages.admin.news.banner.title' | translate"
    [headerHeight]="44"
    [breadcrumbs]="breadcrumbs"
    [addButtonConfiguration]="addButtonConfiguration"
  />

  <div class="flex flex-col">
    <form
      class="flex custom-form flex-wrap items-center gap-4"
      data-testid="admin-news-search-form"
      (ngSubmit)="onSearchClick()"
    >
      <mat-form-field class="!min-w-80">
        <mat-label>{{ 'pages.admin.news.languageFilterLabel' | translate }}</mat-label>
        <mat-select [ngModel]="selectedLanguage()" name="selectedLanguage" (ngModelChange)="onLanguageChange($event)">
          @for (language of languageOptions; track language) {
            <mat-option [value]="language">
              {{ 'pages.profile.language.' + (language === 'de' ? 'german' : 'english') | translate }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <button
        mat-flat-button
        color="primary"
        type="submit"
        data-testid="admin-news-search-button"
        [disabled]="store.loading$()"
      >
        @if (store.loading$()) {
          <app-dots-spinner />
        } @else {
          {{ 'shared.search' | translate }}
        }
      </button>
      <hr class="w-full mt-2 mb-6" />
    </form>

    @if (searchedOnce()) {
      @if (hasResults() || store.loading$()) {
        <app-datatable
          data-testid="admin-news-datatable"
          [rowData]="rowData()"
          [columns]="datatableColumns"
          [configurationInput]="datatableConfig"
          [customColumnDef]="[
            { name: 'actions', isSortable: false, template: actionsColumn },
            { name: 'start', isSortable: true, template: startColumn },
            { name: 'end', isSortable: true, template: endColumn },
            { name: 'priority', isSortable: true, template: priorityColumn },
            { name: 'title', isSortable: true, template: titleColumn },
            { name: 'message', isSortable: true, template: messageColumn },
          ]"
          [total]="total()"
          [isInitialDataLoaded]="searchedOnce() && store.news$() !== null"
          [loadingData]="store.loading$()"
          (rowClick)="onRowClick($event.row)"
        />

        <ng-template #startColumn let-row="row">
          <span>{{ row.startDate ? (row.startDate | date: 'dd.MM.yyyy HH:mm') : '-' }}</span>
        </ng-template>

        <ng-template #endColumn let-row="row">
          <span>{{ row.endDate ? (row.endDate | date: 'dd.MM.yyyy HH:mm') : '-' }}</span>
        </ng-template>

        <ng-template #priorityColumn let-row="row">
          <span>{{ row.priority ?? 0 }}</span>
        </ng-template>

        <ng-template #titleColumn let-row="row">
          <span
            matTooltip
            matTooltipPosition="above"
            class="line-clamp-2 text-ellipsis"
            [appTextClampTooltip]="row.title ?? ''"
          >
            {{ row.title ?? '-' }}
          </span>
        </ng-template>

        <ng-template #messageColumn let-row="row">
          <span class="line-clamp-2 text-ellipsis">
            {{ row.message ? stripHtmlTags(row.message) : '-' }}
          </span>
        </ng-template>

        <ng-template #actionsColumn let-row="row">
          <div
            *hasPermission="[EPermissions.newsUpdateAll, EPermissions.newsDeleteAll]"
            class="flex items-center justify-start"
          >
            <button
              mat-icon-button
              class="mat-secondary-transparent-button-color"
              [matMenuTriggerFor]="menu"
              (click)="onMenuButtonClick($event)"
            >
              <app-icon src="/icons/three-dots.svg" alt="More" [size]="16" />
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item *hasPermission="[EPermissions.newsUpdateAll]" (click)="onEditClick($event, row)">
                <span>{{ 'shared.form.edit' | translate }}</span>
              </button>
              <button
                mat-menu-item
                *hasPermission="[EPermissions.newsDeleteAll]"
                [disabled]="!!store.deletingNewsId$()"
                (click)="onDeleteClick($event, row)"
              >
                <span>{{ 'shared.delete' | translate }}</span>
              </button>
            </mat-menu>
          </div>
        </ng-template>
      } @else if (showEmptyState()) {
        <div class="py-16 text-center text-sm text-gray-500" data-testid="admin-news-empty-state">
          {{ 'shared.noResults' | translate }}
        </div>
      }
    }
  </div>
</app-content-container>
